// src/components/auth/Login.jsx
import React, { useState } from 'react';
import AuthForm from './AuthForm';
import AuthManager from '../../../services/dashboard/AuthManager';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../../features/authSlice'; // adjust path if needed
import { fetchCart } from '../../../features/cartSlice';
import { fetchWishlist } from '../../../features/wishlistSlice';
import { fetchCurrentSubscription } from '../../../features/subscriptionSlice';
import { Eye, EyeOff } from "lucide-react";


export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
// Inside Login component
const location = useLocation();
const redirectPath = location.state?.from || '/';


  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
  
    // Basic mobile number regex: 10 digits, starts with 6-9
    const mobileRegex = /^[6-9]\d{9}$/;
  
    // If input looks like a mobile number, validate it
    const isNumeric = /^\d+$/.test(form.username);
    if (isNumeric && !mobileRegex.test(form.username)) {
      setError("Please enter a valid 10-digit mobile number.");
      setLoading(false);
      return;
    }
  
    try {
      const response = await AuthManager.login(form);
  
      if (response?.responseCode === 200) {
        const token = response?.responseData?.token;
        const user = response?.responseData?.userOrAdmin || {};

        dispatch(loginSuccess({ token, user }));
        dispatch(fetchCart(user.userId));
        dispatch(fetchWishlist(user.userId));
        dispatch(fetchCurrentSubscription(user.userId));
        navigate(redirectPath);
      } else {
        setError(response?.responseMessage || 'Login failed');
      }
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };


  return (
    <AuthForm
      title="Login"
      imageSrc="/images/login-illustration.svg"
      footer={
        <span>
          Don't have an account?{' '}
          <a href="/signup" className="text-[#FF7236] font-medium">Sign Up</a>
        </span>
      }
    >
      <form className="space-y-4" onSubmit={handleSubmit}>
        {error && <div className="text-red-500 text-sm">{error}</div>}

        <input
          type="text"
          name="username"
          placeholder="Email or mobile number"
          value={form.username}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-[#FF7236]"
        />
       <div className="relative">
  <input
    type={showPassword ? "text" : "password"}
    name="password"
    placeholder="Password"
    value={form.password}
    onChange={handleChange}
    required
    className="w-full border border-gray-300 rounded px-4 py-2 pr-10 focus:outline-none focus:border-[#FF7236]"
  />
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#FF7236]"
  >
    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
  </button>
</div>

        <div className="text-right text-sm">
          <a href="/forgot-password" className="text-[#FF7236]">Forget Password?</a>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#FF7236] hover:bg-[#EB5E22] text-white py-2 rounded disabled:opacity-50"
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </AuthForm>
  );
}